export default function getUserAgent() {
    const userAgent = navigator.userAgent.toLowerCase().indexOf('chrome') > -1 
                  ? 'chrome': navigator.userAgent.toLowerCase().indexOf('firefox') > -1 
                  ? 'firefox' : 'safari'
    return userAgent;    
}